import { render, staticRenderFns } from "./SPTranslatableContent.vue?vue&type=template&id=276d94ce&scoped=true&"
import script from "./SPTranslatableContent.vue?vue&type=script&lang=ts&"
export * from "./SPTranslatableContent.vue?vue&type=script&lang=ts&"
import style0 from "./SPTranslatableContent.vue?vue&type=style&index=0&id=276d94ce&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276d94ce",
  null
  
)

export default component.exports